import { TicketCategoryEnum } from 'types';

export type __TextType = {
    id: number;
    me?: boolean;
    text: string;
    date: string;
    seen?: boolean;
    files?: { id: number; url: string; name: string }[];
};

export type __TextTicketsType = {
    id: number;
    date: string;
    texts: __TextType[];
};

export type __TicketsType = {
    id: number;
    title: string;
    attachment: string;
    createdAt: string;
    category: string;
    textTickets: __TextTicketsType[];
};

export type __TextChatType = {
    id: number;
    date: string;
    texts: __TextType[];
};

export type __ChatType = {
    id: number;
    title: string;
    profile: string;
    new_message: string;
    createdAt: string;
    last_message: string;
    textChats: __TextChatType[];
};

export const __TicketsListData: __TicketsType[] = [
    {
        id: 1,
        title: 'تیک سبز برای کسب و کارها',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام حوبی؟ چه خبر؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                        files: [
                            { id: 1, url: 'https://test.com', name: 'kala1' },
                            { id: 2, url: 'https://test.com', name: 'kala2' },
                        ],
                    },
                    {
                        id: 2,
                        text: 'خیلی ممنون تو خوبی؟',
                        date: '2024-12-21T07:35:39.367Z',
                        files: [
                            { id: 1, url: 'https://test.com', name: 'kala1' },
                            { id: 2, url: 'https://test.com', name: 'kala2' },
                        ],
                    },
                    {
                        id: 3,
                        text: 'این کلا رو چجوری بخرم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                        files: [
                            { id: 1, url: 'https://test.com', name: 'kala1' },
                            { id: 2, url: 'https://test.com', name: 'kala2' },
                        ],
                    },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                        files: [
                            { id: 1, url: 'https://test.com', name: 'kala1' },
                            { id: 2, url: 'https://test.com', name: 'kala2' },
                        ],
                    },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 4, text: 'باید پول رو جلو پرداخت کنم؟', date: '2024-12-21T07:35:39.367Z' },
                ],
            },
        ],
    },
    {
        id: 2,
        title: 'تیک سبز',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 4, text: 'باید پول رو جلو پرداخت کنم؟', date: '2024-12-21T07:35:39.367Z' },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        title: 'تیک سبز برای کسب و کارها',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 4,
        title: 'تیک سبز',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 5,
        title: 'تیک سبز برای کسب و کارها',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 6,
        title: 'تیک سبز برای کسب و کارها',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 7,
        title: 'تیک سبز برای کسب و کارها',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام حوبی؟ چه خبر؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'خیلی ممنون تو خوبی؟',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 3,
                        text: 'این کلا رو چجوری بخرم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام حوبی؟ چه خبر؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'خیلی ممنون تو خوبی؟',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 3,
                        text: 'این کلا رو چجوری بخرم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 8,
        title: 'تیک سبز برای کسب و کارها',
        attachment: '4',
        category: 'ویژگی ها و امکانات آگهی',
        createdAt: '2024-12-21T07:35:39.367Z',
        textTickets: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2024-12-24T07:35:39.367Z',
                texts: [
                    { id: 1, text: 'سلام حوبی؟ چه خبر؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    { id: 2, text: 'خیلی ممنون تو خوبی؟', date: '2024-12-21T07:35:39.367Z' },
                    { id: 3, text: 'این کلا رو چجوری بخرم؟', me: true, seen: true, date: '2024-12-21T07:35:39.367Z' },
                    {
                        id: 4,
                        text: 'باید پول رو جلو پرداخت کنم؟',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
];

export const __ChatListData: __ChatType[] = [
    {
        id: 1,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                        files: [{ id: 1, url: 'test', name: 'test' }],
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        me: true,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 3,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                        files: [{ id: 1, url: 'test', name: 'test' }],
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 24,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        me: true,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 5,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                        files: [{ id: 1, url: 'test', name: 'test' }],
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 6,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        me: true,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 4,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 5,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 6,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 7,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 8,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
    {
        id: 9,
        createdAt: '2024-12-21T07:35:39.367Z',
        profile:
            'https://static.vecteezy.com/system/resources/previews/010/566/757/non_2x/international-coffee-day-banner-design-with-wooden-background-illustration-vector.jpg',
        last_message: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
        new_message: '2',
        title: 'بوتیک مردانه ریسک',
        textChats: [
            {
                id: 1,
                date: '2024-12-21T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
            {
                id: 2,
                date: '2025-02-27T07:35:39.367Z',
                texts: [
                    {
                        id: 1,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        me: true,
                        seen: true,
                        date: '2024-12-21T07:35:39.367Z',
                    },
                    {
                        id: 2,
                        text: 'سلام وقت بخیر موجودی شلوار جین هاتون رو لطفا افزایش بدین که بخریم',
                        date: '2024-12-21T07:35:39.367Z',
                    },
                ],
            },
        ],
    },
];

export const __TicketCategoryData: { title: string; value: string | number }[] = [
    {
        title: 'ثبت و مدیریت آگهی',
        value: TicketCategoryEnum.postIssues,
    },
    {
        title: 'مالی',
        value: TicketCategoryEnum.finance,
    },
    {
        title: 'دسته بندی ها',
        value: TicketCategoryEnum.categories,
    },
    {
        title: 'انتقادها و پیشنهادات',
        value: TicketCategoryEnum.suggestion,
    },
    {
        title: 'مشکل نرم افزاری',
        value: TicketCategoryEnum.bug,
    },
    {
        title: 'سایر',
        value: TicketCategoryEnum.other,
    },
];
